import { Link, useParams, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { getNextSection, getPreviousSection, getFirstSection, getLastSection, formatRouteText, formatForRoute, formatTitle } from "./utils";

const BottomNavigation = () => {
  const { reportType, year } = useParams();

  const location = useLocation();
  const splitPath = location.pathname.split("/");
  const path = splitPath[1] + "/" + splitPath[2];

  const sectionTitle = splitPath[splitPath.length - 2];
  const subsectionTitle = splitPath[splitPath.length - 1];

  const firstSection = getFirstSection();
  const lastSection = getLastSection()?.split(" - ").join(" ");


  return (
    <div className="bottom-nav">
      {sectionTitle !== firstSection &&
        <div className="link-bottom-nav-box-container">
          <Link className="route-links bottom-nav-link" to={`/${path}/${reportType}/${year}/${formatForRoute(getPreviousSection(sectionTitle, subsectionTitle))}`}>
            <div className="bottom-nav-box">
              <div className="bottom-nav-direction">
                <ArrowBackIcon />
                <span>Previous</span>
              </div>
              <div className="bottom-nav-section-title">
                {formatRouteText(formatTitle(getPreviousSection(sectionTitle, subsectionTitle)))}
              </div>
            </div>
          </Link>
        </div>
      }
      {subsectionTitle !== lastSection &&
        <div className="link-bottom-nav-box-container">
          <Link className="route-links bottom-nav-link" to={`/${path}/${reportType}/${year}/${formatForRoute(getNextSection(sectionTitle, subsectionTitle))}`}>
            <div className="bottom-nav-box">
              <div className="bottom-nav-direction">
                <span>Next</span>
                <ArrowForwardIcon />
              </div>
              <div className="bottom-nav-section-title">
                {formatRouteText(formatTitle(getNextSection(sectionTitle, subsectionTitle)))}
              </div>
            </div>
          </Link>
        </div>
      }
    </div>
  )
}

export default BottomNavigation;